/**
 * Maps a task's status (column title) to a progress percentage.
 * This is the single source of truth for progress calculation in the frontend.
 * 
 * @param {string} statusTitle - The title/name of the column/status
 * @returns {number} - Progress percentage (0-100)
 */
export const getProgressFromStatus = (statusTitle) => {
  if (!statusTitle) return 0;

  const status = statusTitle.toLowerCase().trim();

  switch (status) {
    case 'todo':
    case 'pending':
    case 'backlog':
      return 0;
    case 'blocked':
    case 'on hold':
    case 'on_hold':
      return 25;
    case 'in progress':
    case 'in-progress':
    case 'in_progress':
    case 'doing':
    case 'working':
      return 50;
    case 'review':
    case 'testing':
    case 'qa':
      return 75;
    case 'done':
    case 'completed':
    case 'complete':
    case 'finished':
      return 100;
    default:
      // Fallback for custom columns - check for keywords
      if (status.includes('todo') || status.includes('pending') || status.includes('backlog')) return 0;
      if (status.includes('blocked') || status.includes('hold')) return 25;
      if (status.includes('progress') || status.includes('doing') || status.includes('working')) return 50;
      if (status.includes('review') || status.includes('testing') || status.includes('qa')) return 75;
      if (status.includes('done') || status.includes('finish') || status.includes('complete')) return 100;
      
      return 0;
  }
};

/**
 * Formats a date string for display.
 * @param {string} dateString - ISO date string
 * @returns {string} - Formatted date (e.g. Jan 12, 2026)
 */
export const formatDate = (dateString) => {
  if (!dateString) return 'No due date';
  try {
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return dateString;
    return date.toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric'
    });
  } catch {
    return dateString;
  }
};
